module.exports = __webpack_public_path__ + "static/media/r6.6d3aa359.png";